import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useHomeContext } from "../../provider/HomeProvider";
import AnimalSafariSkeleton from "components/common/Skeleton/animal/AnimalSafariSkeleton";

function AnimalSafari() {
  const { loading, rareAnimals } = useHomeContext();
  return (
    <section className="animal-wrapper paddiinTop_add">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="title_web">
              <h2>
                RARE AND EXOTIC <br /> ANIMAL SAFARIS
              </h2>
            </div>
          </Col>
        </Row>
      </Container>


      {(Array.isArray(rareAnimals) && rareAnimals?.length > 0) ? (
        rareAnimals?.map((animal) => (
          <div className="animal-safari mb-4" key={animal.id}>
            <Link to={`/animal/${animal.slug}`}>
              <div className="inner_animals position-relative">
                <img src={animal.banner_image_path} alt={animal.name} className="w-100" />
                <div className="safariBox">
                  <Container>
                    <Row className="align-items-center">
                      <Col lg={6} md={5} xs={4} className="text-center">
                        <img
                          src={animal.image_path}
                          alt={animal.name}
                          className="imag_width"
                        />
                      </Col>
                      <Col lg={6} md={7} xs={8}>
                        <div className="safari_content">
                          <h3>{animal.name}</h3>
                          <p className="two-line-text">{animal.short_description}</p>
                          <div className="knowmore">
                            <div className="btn-knowmore mb-0">Know More</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </Link>
          </div>
        )))
        : loading ? (
          <>
            {[1, 2, 3, 4, 5].map((_, index) => (
              <AnimalSafariSkeleton />
            ))}
          </>
        ) : (
          <p>No safaris available</p>
        )}
    </section>
  );
}

export default AnimalSafari;
